import { CALENDAR_EVENT_TYPES, CALENDAR_REMOVAL_TEXTS } from '@fos/shared/contracts/calendar';
import type { EventDto } from '@fos/shared/contracts/inbox';
import { ArchiveRestore } from 'lucide-react';
import { errorMessage } from '../../../lib/api';
import { trpc } from '../../../lib/trpc';
import { Button } from '../../../ui/Button';
import { toast } from '../../../ui/Toast';

/** Spotkanie z powiadomienia „Spotkanie X zostało usunięte w Kalendarzu Google” (albo null dla innych zdarzeń). */
export function removedMeetingId(event: Pick<EventDto, 'type' | 'links'>): string | null {
  if (event.type !== CALENDAR_EVENT_TYPES.meetingRemoved) return null;
  return event.links.find((l) => l.type === 'meeting')?.id ?? null;
}

/**
 * „Przywróć spotkanie” przy powiadomieniu o spotkaniu usuniętym w Kalendarzu Google (DECISIONS 2026-10-10 [S]
 * „Usunięte w Kalendarzu Google = archiwum”): ta sama usługa co „Przywróć z archiwum” w karcie spotkania
 * (`meetings.restore` — zaproszenie wraca do kalendarza), potem pozycja Inboxu = Zrobione. Spotkanie już
 * przywrócone albo poza zakresem osoby = bez przycisku (uprawnienia sprawdza backend).
 */
export function RestoreRemovedMeeting({ meetingId, onRestored }: { meetingId: string; onRestored: () => void }) {
  const utils = trpc.useUtils();
  const meeting = trpc.meetings.get.useQuery({ id: meetingId }, { retry: false });
  const restore = trpc.meetings.restore.useMutation({
    onSuccess: async () => {
      await utils.meetings.invalidate();
      toast.success(CALENDAR_REMOVAL_TEXTS.restored);
      onRestored();
    },
    onError: (err) => toast.error(errorMessage(err, 'Nie udało się przywrócić spotkania.')),
  });
  const m = meeting.data;
  if (!m?.archivedAt) return null;
  return (
    <Button
      variant="primary"
      icon={ArchiveRestore}
      loading={restore.isPending}
      onClick={() => restore.mutate({ id: m.id, version: m.version })}
    >
      {CALENDAR_REMOVAL_TEXTS.restore}
    </Button>
  );
}
